/**
 * オブジェクトの中身が空かどうかを判別する関数
 * 空ならfalse、中身があるならtrueを返す
 * @param obj 入力オブジェクト
 * @returns 判定結果
 */
const isObjectEmpty = (obj: object): boolean => {
  return !Object.keys(obj).length;
};

export { isObjectEmpty };
